import { render, staticRenderFns } from "./webAppList.vue?vue&type=template&id=25fad77e&scoped=true&"
import script from "./webAppList.vue?vue&type=script&lang=js&"
export * from "./webAppList.vue?vue&type=script&lang=js&"
import style0 from "./webAppList.vue?vue&type=style&index=0&id=25fad77e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fad77e",
  null
  
)

export default component.exports